import { apiInstance } from "@/api/instance";

export default async function (lectureId) {
  return apiInstance.get(`/lecture/${lectureId}`);
}
